import React from 'react';
import { Icon, Checkbox } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { S3_ASSETS_PATH } from '../constants';

const useStyles = makeStyles({
  imageIcon: {
    height: '100%',
    width: '100%',
  },
  iconRoot: {
    textAlign: 'center',
    width: 18,
    height: 18,
  },
});
export default function CheckBox({
  checked,
  handleCheckbox,
  id,
  name,
  disabled,
}) {
  // console.log('checked', checked)
  const classes = useStyles();
  return (
    <Checkbox
      checked={checked}
      disabled={disabled ? true : false}
      icon={
        <Icon classes={{ root: classes.iconRoot }}>
          <img
            className={classes.imageIcon}
            src={`${S3_ASSETS_PATH}/images/MNO/unchecked-new.svg`}
          />
        </Icon>
      }
      checkedIcon={
        <Icon classes={{ root: classes.iconRoot }}>
          <img
            className={classes.imageIcon}
            src={`${S3_ASSETS_PATH}/images/dca_checked_icon.svg`}
          />
        </Icon>
      }
      id={id}
      onChange={(e) => handleCheckbox(e)}
      className="custom-checkbox"
      name={name}
    />
  );
}
